import { Component, OnDestroy } from '@angular/core';
import { NavController,AlertController,ToastController,ViewController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';

import { provider } from '../../../providers/provider';
import { CustomizerProvider } from '../../../providers/customizer/customizer';

@Component({
  selector: 'page-customercard',
  templateUrl: 'customercard.html'
})
export class CustomerCardPage implements OnDestroy {
  restaurant: any;
  tessere = [];
  choice = 'associa';
  private _onDestroy = new Subject();
  customerInfo;
  fidelity = { code: '' };
  tessera;
  customerCode;

  constructor(public navCtrl: NavController,
              public translateService: TranslateService,
              public storage: Storage,
              public toastCtrl: ToastController,
              public alertCtrl: AlertController,
              public provider: provider,
              public viewCtrl: ViewController,
              public customizer: CustomizerProvider) {

    this.getCustomer();
    this.customerCode = (provider.getMenu()).settings.customercode;
  }

  getCustomer() {
    this.storage.get('customer').then((customer) => {
      this.customerInfo = JSON.parse(customer);
      this.backup();
    });
  }

  associate() {
    let message;
    this.provider.setCard(this.customerInfo.telephone, this.fidelity.code, this.customerInfo._id).takeUntil(this._onDestroy).subscribe(data => {
      this.cardBalance((<any>data)._body);
    }, err => {
      
      if(err._body == "E1012") {
        this.translateService.get('E1012').takeUntil(this._onDestroy).subscribe(value => {
          message = err._body + " - " + value 
        });
      } else {
        message = err._body;
      }

      let toast = this.toastCtrl.create({
        message: message,
        duration: 3000,
        position: 'middle'
      });
      toast.present();
    });
  }

  backup() {
    this.provider.cardsBackup(this.customerInfo.telephone, this.customerInfo._id).takeUntil(this._onDestroy).subscribe(data => {
      let tessere = JSON.parse((<any>data)._body);
      tessere.forEach(element => {
        this.storage.set(element.customercode, element.hash);
      });
      this.storage.get(this.customerCode).then((hash) => {
        this.cardBalance(hash);
      })
    }, err => {
    });
  }

  cardBalance(hash) {
    this.provider.getCardBalance(hash).takeUntil(this._onDestroy).subscribe(data => {
      this.tessera = JSON.parse((<any>data)._body);
    }, err => {
    });
  }

  ngOnDestroy() {
    this._onDestroy.next();
  }

}



// WEBPACK FOOTER //
// ./src/pages/account/customercard/customercard.ts